import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy alias for the old stack's company-scoped sign-out page; the slug is
// accepted and ignored, as on the login alias.
//
// Public because its target is: `/logout` is the branded logout page, which a
// visitor whose session has already gone must be able to reach. Now that the
// page is on the route tree the hop travels as a type-checked `to` rather than
// an off-tree `href` — the compiler, not a test, is what keeps the destination
// real. `replace` so Back from the confirmation does not re-enter the alias.
export const Route = createFileRoute("/$companySlug/logout")({
  beforeLoad: () => {
    throw redirect({ to: "/logout", replace: true });
  },
});
